<template>
    <!-- <div class="container mt-5"> -->
      <div class="container mt-5 bg-transparent">
      <h2 class="mb-4 text-primary">🎓 Teacher Payment Management</h2>
  
      <!-- Teacher Selection Dropdown -->
      <!-- Teacher Selection Dropdown -->
<div class="row mb-4">
  <div class="col-12 col-md-4 mb-3 mb-md-0">
    <!-- <label for="teacher" class="font-weight-bold">Select Teacher:</label> -->
    <select v-model="selectedTeacher" class="form-control shadow-sm" id="teacher">
      <option value="">-- All Teachers --</option>
      <option v-for="teacher in teachers" :key="teacher.id" :value="teacher.id">
        {{ teacher.user.first_name }}
      </option>
    </select>
  </div>

  <div class="col-12 col-md-4 mb-3 mb-md-0">
    <!-- <label for="subject" class="font-weight-bold">Select Subject:</label> -->
    <select v-model="selectedSubject" class="form-select shadow-sm" id="subject">
      <option value="">All Subjects</option>
      <option v-for="subject in subjects" :key="subject.id" :value="subject.id">
        {{ subject.name }}
      </option>
    </select>
  </div>

  <div class="col-12 col-md-4">
    <!-- <label for="dateFilter" class="font-weight-bold">Filter by Date:</label> -->
    <select v-model="selectedDateFilter" class="form-control shadow-sm" id="dateFilter">
      <option value="all">All Dates</option>
      <option value="today">Today</option>
      <option value="last_week">Last Week</option>
      <option value="last_month">Last Month</option>
    </select>
  </div>
</div>


  
      <!-- Total Payment Display -->
      <div class="alert alert-success text-right mb-4">
        <strong>Total Payment :</strong> {{ totalAllTeachers.toFixed(2) }}
      </div>
  
      <!-- Loading Spinner -->
      <div v-if="loading" class="text-center my-4">
        <div class="spinner-border text-primary" role="status"></div>
      </div>
  
      <!-- Payments Table -->
      <div v-if="!loading">
        <div v-if="teacherPayments && teacherPayments.length" class="mt-4">
          <h3 class="text-center my-4 text-dark">📊 Teacher Payments Summary</h3>
  
          <div class="table-responsive">
  <!-- <table class="table table-bordered table-striped shadow-sm"> -->
    <table class="table table-hover table-bordered align-middle shadow-sm">
            <thead class="thead-dark">
              <tr>
                <th>Teacher Name</th>
                <th>Subject</th> <!-- Added Subject -->
                <th>Total Payment</th>
                <th>Price Rate</th>
                <th>Teacher Payment</th>
                <th>Action</th> <!-- Added Action header -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="payment in teacherPayments" :key="payment.teacher_id">
                <td data-label="Teacher Name">{{ payment.teacher_name }}</td>
                <td data-label="Subject">{{ payment.subject_name }}</td> <!-- Show Subject Name -->
                <td data-label="Total Payment">{{ payment.total_payment }}</td>
                <td data-label="Price Rate">{{ payment.price_rate }}</td>
                <!-- <td>{{ payment.teacher_payment }}</td> -->
                 <td data-label="Teacher Payment">{{ Number(payment.teacher_payment || 0).toFixed(2) }}</td>

                <td data-label="Action">
                  <button type="button" class="btn btn-primary" data-bs-toggle="modal" :data-bs-target="'#tiaddpayModal' + payment.teacher_id">
                    Add Pay
                  </button>
                  <!-- Modal Specific to Teacher -->
                   <div class="modal fade" :id="'tiaddpayModal' + payment.teacher_id" tabindex="-1" aria-labelledby="tiaddpayModalLabel" aria-hidden="true">
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h1 class="modal-title fs-5" id="tiaddpayModalLabel">Payment</h1>
                          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                          <!-- teacherPayment="payment.teacher_payment" -->
                          <TIAddPayModal
                          :teacherPayment="Number(parseFloat(payment.teacher_payment).toFixed(2))"
                          :teacherId="payment.teacher_id"
                          :teacherName="payment.teacher_name"
                          :subjectName="payment.subject_name"
                          :subjectId="payment.subject_id"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
  
          <!-- Pagination -->
          <nav v-if="totalPages > 1" class="mt-3">
            <ul class="pagination justify-content-center">
              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">Previous</a>
              </li>
  
              <li class="page-item"
                  v-for="page in totalPages"
                  :key="page"
                  :class="{ active: currentPage === page }">
                <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
              </li>
  
              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">Next</a>
              </li>
            </ul>
          </nav>
        </div>
  
        <!-- No Payments Message -->
        <div v-else>
          <p class="text-danger text-center mt-3">No payments available for this filter.</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import TIAddPayModal from '@/components/InstituteDashboard/PaymentPages/PaymentModel/TIAddPayModal.vue'; 
  export default {
    components: {
      TIAddPayModal,
    },
    data() {
      return {
        teachers: [],
        selectedTeacher: '',
        teacherPayments: [],
        selectedSubject: "",
        subjects: [],
        selectedDateFilter: 'all',
        loading: false,
        totalAllTeachers: 0,
        currentPage: 1,
        perPage: 1,
        totalPages: 1,
      };
    },
    mounted() {
      this.fetchTeachers();
      this.fetchSubjects();
      this.fetchTeacherPayments(); // Initial load
    },
    watch: {
      selectedTeacher() {
        this.currentPage = 1;
        this.fetchSubjects(); 
        this.fetchTeacherPayments();
      },
      selectedDateFilter() {
        this.currentPage = 1;
        this.fetchTeacherPayments();
      },
      selectedSubject() {  // NEW
      this.currentPage = 1;
      this.fetchTeacherPayments();
    }
    },
    methods: {
      fetchTeachers() {
        const instituteId = localStorage.getItem('institute_id');
  
        axios.get('/get-teachers-by-institute', {
          params: { institute_id: instituteId }
        })
        .then(response => {
          this.teachers = response.data;
        })
        .catch(error => {
          console.error('Error fetching teachers:', error);
        });
      },
      async fetchSubjects() {
      const instituteId = localStorage.getItem("institute_id");
      try {
        const response = await axios.post("/get-teacher-subjects-for-institute", {
          institute_id: instituteId,
          teacher_id: this.selectedTeacher || null, // ✅ Send only if available
        });
        this.subjects = response.data;
      } catch (error) {
        console.error("Failed to fetch subjects:", error);
      }
    },
  
      fetchTeacherPayments() {
        this.loading = true;
        const instituteId = localStorage.getItem('institute_id');
  
        axios.get('/get-teacher-payments', {
          params: {
            institute_id: instituteId,
            teacher_id: this.selectedTeacher,
            subject_id: this.selectedSubject,
            date_filter: this.selectedDateFilter,
            page: this.currentPage,
            per_page: this.perPage
          }
        })
        .then(response => {
          this.teacherPayments = response.data.data;
          this.totalAllTeachers = response.data.total_all_teachers;
          this.totalPages = Math.ceil(response.data.total / this.perPage);
        })
        .catch(error => {
          console.error('Error fetching teacher payments:', error);
        })
        .finally(() => {
          this.loading = false;
        });
      },
  
      changePage(page) {
        if (page >= 1 && page <= this.totalPages) {
          this.currentPage = page;
          this.fetchTeacherPayments();
        }
      }
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .container {
  max-width: 1200px;
  padding: 0rem;
  border-radius: 1rem;
  // box-shadow: 0 0 30px rgba(0, 0, 0, 0.08);
}

h2 {
  font-weight: 700;
  color: #2c3e50;
  border-bottom: 2px solid #3498db;
  padding-bottom: 10px;
}

label {
  font-size: 1rem;
  margin-bottom: 0.3rem;
  color: #2c3e50;
}

.form-select,
.form-control {
  min-height: 38px;
}


.form-group select:focus {
  border-color: #3498db;
  box-shadow: 0 0 0 0.2rem rgba(52, 152, 219, 0.25);
}

.alert-success {
  background-color: #eafaf1;
  border-left: 5px solid #27ae60;
  font-weight: 600;
}

.table {
  border-radius: 0.5rem;
  overflow: hidden;
  margin-top: 1rem;
}

.table thead {
  background-color: #2c3e50;
  color: #ffffff;
}

.table th,
.table td {
  text-align: center;
  vertical-align: middle;
}

.btn-primary {
  background-color: #3498db;
  border-color: #3498db;
  border-radius: 0.4rem;
  transition: background-color 0.3s ease;
}

.btn-primary:hover {
  background-color: #2980b9;
}

.page-link {
  color: #3498db;
  font-weight: 600;
  border-radius: 0.3rem;
}

.page-link:hover {
  color: #ffffff;
  background-color: #3498db;
}

.text-danger {
  font-weight: 600;
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .container {
  max-width: 300px;
  padding: 0 0px;
}

.form-select {
  min-width: 300px;
}

table thead {
    display: none; /* Hide table headers */
  }

  table, table tbody, table tr, table td {
    display: block;
    width: 100%;
  }

  table tr {
    margin-bottom: 15px;
    border-bottom: 2px solid #ddd;
  }

  table td {
    text-align: right;
    padding-left: 50%;
    position: relative;
  }

  table td::before {
    content: attr(data-label);
    position: absolute;
    left: 15px;
    width: 45%;
    white-space: nowrap;
    text-align: left;
    font-weight: bold;
  }

}

  </style>
  